import { useBookEditor } from "./BookEditorProvider";

const MODES = [
  { id: "write", label: "Write" },
  { id: "design", label: "Design" },
  { id: "canvas", label: "Canvas" },
  { id: "preview", label: "Preview" },
];

export default function BookEditorModeTabs() {
  const { bookId, mode, setMode } = useBookEditor();

  const selectMode = (nextMode) => {
    setMode(nextMode);
  };

  return (
    <div
      className="book-editor-mode-tabs"
      role="tablist"
      aria-label="Book editor mode"
      data-testid="book-editor-mode-tabs"
    >
      {MODES.map((item) => (
        <button
          key={item.id}
          type="button"
          role="tab"
          aria-selected={mode === item.id}
          data-testid={`book-editor-mode-${item.id}`}
          className={
            mode === item.id
              ? "book-editor-mode-tab is-active"
              : "book-editor-mode-tab"
          }
          onClick={() => selectMode(item.id)}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
}
